import {
  Box, Typography, Container, styled,
} from '@material-ui/core';

export const ContentContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minHeight: '100vh',
});

export const FlexContainer = styled(Container)({
  flex: 1,
});

export const HeroImage = styled('img')({
  display: 'block',
  margin: '0 auto',
  paddingTop: 32,
  width: 206,
});

export const TextSection = styled(Box)({
  textAlign: 'center',
  paddingTop: 32,
});

export const Title = styled(Typography)({
  marginBottom: 8,
});

export const Subtitle = styled(Typography)({
  marginTop: 8,
  marginBottom: 16,
});

export const SectionTitle = styled(Typography)({
  fontWeight: 700,
});

export const ResendBox = styled(Box)(({ theme }) => ({
  width: '100%',
  borderRadius: 12,
  backgroundColor: theme.palette.grey[300],
  padding: theme.spacing(2.5),
  marginTop: theme.spacing(2),
}));
